// @flow
import type { ERROR_TYPE } from './common';

export type DRIVER_TYPE = {
  id: number,
  first_name: string,
  last_name: string,
  license_type: string,
  profile_picture: string
};

export type DRIVER_FETCH_STARTED_TYPE = {
  type: 'DRIVER_FETCH_STARTED',
  payload: number
};
export const DRIVER_FETCH_STARTED = 'DRIVER_FETCH_STARTED';

export type DRIVER_FETCH_SUCCEED_TYPE = {
  type: 'DRIVER_FETCH_SUCCEED',
  payload: DRIVER_TYPE
};
export const DRIVER_FETCH_SUCCEED = 'DRIVER_FETCH_SUCCEED';

export type DRIVER_FETCH_FAILED_TYPE = {
  type: 'DRIVER_FETCH_FAILED',
  payload: ERROR_TYPE
};
export const DRIVER_FETCH_FAILED = 'DRIVER_FETCH_FAILED';

export type DRIVER_ACTION_TYPE =
  | DRIVER_FETCH_STARTED_TYPE
  | DRIVER_FETCH_SUCCEED_TYPE
  | DRIVER_FETCH_FAILED_TYPE;



// WEBPACK FOOTER //
// ./src/scripts/types/drivers.js